import React from "react";
import styled from "styled-components";
import { Button } from "components/bootstrap";
import ExternalLink from "components/common/ExternalLink";
export const EXTERNAL_LINK_INNER_CLASS = "external-link-inner";
const StyledButton = styled(Button)`
  .${EXTERNAL_LINK_INNER_CLASS} {
    display: flex;
    align-items: center;
  }
`;
const ExternalLinkButton = ({
  bsStyle = "default",
  target = "_blank",
  className = "",
  disabled = false,
  iconName = "open_in_new",
  children = void 0,
  ...props
}) => /* @__PURE__ */ React.createElement(StyledButton, { bsStyle, target, className, disabled, ...props }, /* @__PURE__ */ React.createElement(ExternalLink, { iconName }, children));
export default ExternalLinkButton;
